import styled from "@emotion/styled"

export const MainContainer = styled.div`
  background: #000;
  padding: 50px 0px;
  margin-top: 10px;
`

export const SponsorImage = styled.div`
  background-image: url(${props => props.image});
  width: 200px;

  height: 67px;
  margin: auto;
`

export const InnerContainer = styled.div`
  width: 60%;
  display: grid;
  margin: auto;
  grid-template-columns: auto auto auto auto;
  grid-gap: 44px;
  @media (max-width: 1302px) {
    grid-template-columns: auto auto auto;
  }
  @media (max-width: 870px) {
    grid-template-columns: auto auto;
  }
  @media (max-width: 560px) {
    grid-template-columns: auto;
  }
`

export const Heading = styled.div`
  background-color: #990000;
  margin-bottom: 24px;
  color: #ffffff;
  font-family: Montserrat, sans-serif;
  font-size: 50px;
  font-weight: 700;
  line-height: 2em;
  text-align: center;
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 560px) {
    font-size: 36px;
  }
`
